(function () {
  'use strict';

  function initArticleShare(root) {
    if (root.dataset.shareReady === 'true') return;

    var trigger = root.querySelector('.merlons-article-share__trigger');
    var fallback = root.querySelector('.merlons-article-share__fallback');
    var closeButton = root.querySelector('[data-share-close]');
    var copyButton = root.querySelector('[data-share-copy]');
    var status = root.querySelector('[data-share-status]');
    if (!trigger || !fallback) return;

    var title = root.dataset.shareTitle || document.title;
    var shareUrl = root.dataset.shareUrl || window.location.href;
    var previousFocus = null;
    var focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function setStatus(message) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    function focusableElements() {
      return Array.prototype.slice.call(fallback.querySelectorAll(focusableSelector)).filter(function (element) {
        return !element.hidden && element.offsetParent !== null;
      });
    }

    function openFallback(message) {
      previousFocus = document.activeElement;
      fallback.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      setStatus(message);
      var focusable = focusableElements();
      (focusable[0] || fallback).focus();
    }

    function closeFallback() {
      fallback.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      setStatus('');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      previousFocus = null;
    }

    function copyText() {
      var copied = function () { setStatus(root.dataset.copySuccess || ''); };
      var failed = function () { setStatus(root.dataset.copyFailure || ''); };
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(shareUrl).then(copied).catch(failed);
        return;
      }

      var textArea = document.createElement('textarea');
      textArea.value = shareUrl;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        if (document.execCommand('copy')) copied(); else failed();
      } catch (error) {
        failed();
      }
      document.body.removeChild(textArea);
    }

    trigger.addEventListener('click', function () {
      if (navigator.share && typeof navigator.share === 'function') {
        navigator.share({ title: title, url: shareUrl }).catch(function (error) {
          if (error && error.name === 'AbortError') return;
          openFallback(root.dataset.shareFailure || '');
        });
        return;
      }
      openFallback('');
    });

    if (closeButton) closeButton.addEventListener('click', closeFallback);
    if (copyButton) copyButton.addEventListener('click', copyText);

    fallback.addEventListener('click', function (event) {
      if (event.target === fallback) closeFallback();
    });

    fallback.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFallback();
        return;
      }
    });

    document.addEventListener('click', function (event) {
      if (!fallback.hidden && !root.contains(event.target)) closeFallback();
    });

    root.dataset.shareReady = 'true';
  }

  function init() {
    document.querySelectorAll('[data-merlons-article-share]').forEach(initArticleShare);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
